import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../firebase';
import { todayKey } from '../buffetUtils';

/**
 * Live subscription to today's buffet orders. Filters by dateKey (so each day
 * starts clean) and sorts oldest-first client-side to avoid a composite index.
 */
export function useBuffetOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const q = query(collection(db, 'buffetOrders'), where('dateKey', '==', todayKey()));
    const unsub = onSnapshot(
      q,
      snap => {
        const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => (a.createdAtMs || 0) - (b.createdAtMs || 0));
        setOrders(list);
        setLoading(false);
      },
      e => { setError(e.message); setLoading(false); }
    );
    return () => unsub();
  }, []);

  return { orders, loading, error };
}
